import { Box, Typography } from "@mui/material";
import StyledTitleDot from "../../components/common/StyledTitleDot";
import BreadCrumbs from "../../components/Breadcrumbs";
import AddUserComponent from "../../components/Settings/AddUser";
import { UsersListProvider } from "../../contexts/UsersList/UsersList";
import { useTranslation } from "react-i18next";

export default function AddUser() {
  const { t } = useTranslation()
  return (
    <UsersListProvider>
      <Typography sx={{
        textTransform: 'capitalize'
      }} className="title" variant="h4">
        {t("addUser")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("addUser")]} />

      <Box sx={{ marginTop: "2rem" }}>
        <AddUserComponent />
      </Box>
    </UsersListProvider>
  );
}
